import { TableCell, TableRow } from "../../../../components";
import { Skeleton } from "../../../../components/common";
import { Row } from "../../../../components/row";

export function KpiSkeleton({ cards = 5 }: { cards?: number }) {
  const gridClassName =
    cards === 5
      ? "grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5"
      : "grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4";

  return (
    <div className={gridClassName} data-testid="kpi-skeleton">
      {Array.from({ length: cards }, (_, index) => (
        <div key={index}>
          <div className="space-y-2 rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800">
            <div className="flex items-center justify-between">
              <Skeleton className="h-4 w-2/3" />
              <Skeleton className="h-8 w-8 rounded-lg" />
            </div>
            <Skeleton className="h-7 w-1/2" />
            <Skeleton className="h-3 w-3/4" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function FilterControlsSkeleton({ fields = 4 }: { fields?: number }) {
  return (
    <div
      className="flex flex-1 flex-row items-end gap-4 px-6 py-3"
      data-testid="filter-controls-skeleton"
    >
      {Array.from({ length: fields }, (_, index) => (
        <div
          key={index}
          className="w-full flex-1 space-y-2"
        >
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-12 w-full rounded-lg" />
        </div>
      ))}
    </div>
  );
}

export function MapBodySkeleton() {
  return (
    <div
      className="relative flex-1 rounded-2xl p-4"
      data-testid="map-body-skeleton"
    >
      <Skeleton className="h-full min-h-[480px] w-full rounded-2xl" />
    </div>
  );
}

export function SidePanelSkeleton() {
  return (
    <div
      className="flex h-full w-3/12 flex-col space-y-3 rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-700 dark:bg-gray-800"
      data-testid="side-panel-skeleton"
    >
      <Skeleton className="h-5 w-1/2" />
      <Skeleton className="h-24 w-full rounded-xl" />
      <Skeleton className="h-24 w-full rounded-xl" />
      <Skeleton className="h-24 w-full rounded-xl" />
    </div>
  );
}

export function TableRowsSkeleton({ colSpan, rows = 5 }: { colSpan: number; rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, index) => (
        <TableRow
          key={index}
          className="hover:bg-transparent"
          data-testid="table-row-skeleton"
        >
          <TableCell colSpan={colSpan}>
            <Skeleton className="h-6 w-full" />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}

export function PartnerListSkeleton({ cards = 3 }: { cards?: number }) {
  return (
    <div
      className="flex-1 space-y-4 overflow-hidden p-4"
      data-testid="partner-list-skeleton"
    >
      {Array.from({ length: cards }, (_, index) => (
        <div
          key={index}
          className="space-y-2 rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800"
        >
          <Skeleton className="h-5 w-2/3" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      ))}
    </div>
  );
}
